import React, { useEffect, useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
  Box,
  Typography,
  Radio,
} from "@mui/material";
import moment from "moment";
import Iconify from "../iconify";
import { patch } from "src/utils/networkUtils";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const DraftDrawTable = ({ rows, handleOpenMenu }) => {
  const [selectedRows, setSelectedRows] = useState({});

  useEffect(() => {
    const initial = {};
    rows.forEach((row) => {
      initial[row.prizeDrawId] = row.isCompleted;
    });
    setSelectedRows(initial);
  }, [rows]);

  const handleOnChange = async (event, rowId) => {
    try {
      console.log(`/admin/raffles/${rowId}/status`)
      const resp = await patch(`/admin/raffles/${rowId}/status`, {
        status: 1
      });
      if (resp.success) {
        window.location.reload(true);
      }
    } catch (error) {
      setSelectedRows((prev) => ({
        ...prev,
        [rowId]: !event.target.checked,
      }));
    }
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>In Active</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(
            (row, index) =>
              row !== null &&
              row !== undefined && (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.raffleId}
                  </TableCell>

                  <TableCell>
                    <Typography variant="subtitle2">{row.title_en}</Typography>
                  </TableCell>

                  <TableCell>
                    {moment(row.startDate).format("ddd MMM D, YYYY")}
                  </TableCell>

                  <TableCell>
                    <Radio
                      checked={!!selectedRows[row.raffleId]}
                      onChange={(e) =>
                        handleOnChange(e, row.raffleId)
                      }
                      size="small"
                      sx={{ padding: 0.5 }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(event) => {
                        handleOpenMenu(event, row);
                      }}
                      id={row.prizeDrawId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DraftDrawTable;
